import React from 'react';
import graphql from 'graphql';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import {isMobile} from 'react-device-detect';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import './all.sass';

export const bodyClass = isMobile ? "is-mobile" : "is-browser";
const TemplateWrapper = ({ children, events }) => (
  <div>
    <Helmet
      title="San Juan Software"
      bodyAttributes={{
        class: bodyClass
      }}
      meta={[
        {
            name: 'keywords',
            content: `training, zigbee wireless, 802.15.4, embedded systems, san juan software, san juan, embedded software, wireless, firmware, zigbee`,
        },
        {
            name: 'description',
            content: `An embedded software development company located in Friday Harbor, USA providing ZigBee&trade; wireless software and services.`,
        },
      ]}
    />
    <Navbar title={"San Juan Software"} />
    <div>{children()}</div>
    <Footer events={events} />
  </div>
);

TemplateWrapper.propTypes = {
  children: PropTypes.func,
};

//export default TemplateWrapper;

export default ({ data , children }) => {
  const events = data.EventQuery.frontmatter.events;
  return (<TemplateWrapper
    events={events}
    children={children}
  />);
};

export const HomePageQuery = graphql`
  query HomePageQuery {
    EventQuery: markdownRemark(
      frontmatter: { path: { eq: "/events" } },
    ) {
      frontmatter {
        events {
          title
          startDate
          date
          location
          link
        }
      }
    }
  }
`;


// WEBPACK FOOTER //
// ./src/layouts/index.js